export default "__VITE_ASSET__3e4c601e__"